import { HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EnumSiNo } from '../../../core/_infrastructure/types/common';
import {
    FilterSearchingRechazosTracesViewModel,
    RechazosTracesItemResultsViewModel,
    RechazosTracesNoCumplimientoViewModel,
    RechazosTracesParteIViewModel,
    RechazosTracesParteIIViewModel,
    TNTRetrievalAttachmentViewModel,
} from './rechazostraces.types';

import { ResetFiltersService } from '../../../core/_infrastructure/classes/services/reset-filters.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

@Injectable()
export class RechazosTracesService extends ResetFiltersService {
    rechazosTracesEndpoint = this.baseUrl + 'api/importacion/rechazostraces/';
    arrBooleanKeys = ['BusquedaExacta'];

    private lastSearch?: FilterSearchingRechazosTracesViewModel;
    private lastSearchTransfer?: FilterSearchingRechazosTracesViewModel;

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    private convertModelToHttpParms(payload: FilterSearchingRechazosTracesViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingRechazosTracesViewModel;

        for (k in payload) {
            let v: string | number | boolean | Date;
            const valor = payload[k];
            if (this.arrBooleanKeys.indexOf(k) !== -1 && valor == EnumSiNo.NO) {
                v = 0;
            } else if (valor instanceof Date) {
                v = (valor as Date).toLocaleDateString();
            } else {
                v = valor || '';
            }

            params = params.append(k, v);
        }

        return params;
    }

    getRechazosTraces(payload: FilterSearchingRechazosTracesViewModel): Observable<RechazosTracesItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getRechazosTracesPagedByFilter(params);
    }

    getTrasladosTraces(payload: FilterSearchingRechazosTracesViewModel): Observable<RechazosTracesItemResultsViewModel> {
        this.lastSearchTransfer = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getRechazosTracesPagedByFilter(params);
    }

    getRechazosTracesPagedByFilter(params: HttpParams): Observable<RechazosTracesItemResultsViewModel> {
        return this.http.get<RechazosTracesItemResultsViewModel>(this.rechazosTracesEndpoint + 'pagedbyfilter/', { params: params });
    }

    getLastSearch(): FilterSearchingRechazosTracesViewModel | undefined {
        return this.lastSearch;
    }

    getLastSearchTransfer(): FilterSearchingRechazosTracesViewModel | undefined {
        return this.lastSearchTransfer;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    clearLastSearchTransfer(): void {
        this.lastSearchTransfer = undefined;
    }

    getRechazoTracesParteI(CHEDPP: string): Observable<RechazosTracesParteIViewModel> {
        return this.http.get<RechazosTracesParteIViewModel>(this.rechazosTracesEndpoint + 'GetChedCertificatePartOne/' + CHEDPP);
    }

    getRechazoTracesParteII(CHEDPP: string): Observable<RechazosTracesParteIIViewModel> {
        return this.http.get<RechazosTracesParteIIViewModel>(this.rechazosTracesEndpoint + 'GetChedCertificatePartTwo/' + CHEDPP);
    }

    getRechazoTracesNoCumplimiento(CHEDPP: string): Observable<RechazosTracesNoCumplimientoViewModel> {
        return this.http.get<RechazosTracesNoCumplimientoViewModel>(this.rechazosTracesEndpoint + 'GetChedNonComplianceDetails/' + CHEDPP);
    }

    getDocumentoRechazoTraces(model: TNTRetrievalAttachmentViewModel): Observable<HttpResponse<Blob>> {
        const endpoint = this.rechazosTracesEndpoint + 'GetCertificateAttachment';
        return this.http.post(endpoint, model, { observe: 'response', responseType: 'blob' }).pipe();
    }

    export(model: FilterSearchingRechazosTracesViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.rechazosTracesEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    resetFilter() {
        this.lastSearch = undefined;
        this.lastSearchTransfer = undefined;
    }
}
